import React from 'react';
import cx from 'clsx';
import { useLocation, useQueryParam } from 'src/hooks';
import { Link as GatbsyLink } from 'gatsby';

type LinkColor = 'blue' | 'teal';

interface Props {
  color?: LinkColor,
  href: string,
  onClick?: () => void,
  isExternal?: boolean,
  className?: string,
  style?: React.CSSProperties,
  isUnderlined?: boolean,
}

const Link: React.FC<Props> = ({
  color,
  href,
  isExternal = false,
  className,
  style,
  isUnderlined = true,
  onClick,
  children,
}) => {
  const location = useLocation();
  const experienceVariant = useQueryParam('variant');
  const classNames = cx([
    color === 'blue' && [
      'text-blue',
      'hover:text-blue-hover',
    ],
    color === 'teal' && [
      'text-teal',
      'hover:text-teal-hover',
    ],
    isUnderlined && 'underline',
    isUnderlined && 'hover:underline',
  ], className);
  if (isExternal) {
    return (
      <a
        href={href}
        target={href.startsWith('mailto:') ? undefined : '_blank'}
        rel="noreferrer"
        className={classNames}
        style={style}
      >
        {children}
      </a>
    );
  }
  // Preserve the variant across links
  let finalHref = href;
  if (location && !href.startsWith('http')) {
    const url = new URL(href, location?.origin);
    if (experienceVariant) {
      if (experienceVariant) url.searchParams.append('variant', experienceVariant);
    }
    finalHref = `${url.pathname}${url.search}`;
  }
  return (
    <GatbsyLink to={finalHref} className={classNames} style={style} onClick={onClick}>
      {children}
    </GatbsyLink>
  );
};

export default Link;
